import React from 'react'
import { StatusBadge } from './StatusBadge'
import './ClientHeader.css'

interface ClientHeaderProps {
  fullName: string
  netWorthCategory?: string
  advisorName?: string
  clientSince?: string
  isActive: boolean
}

export const ClientHeader: React.FC<ClientHeaderProps> = ({
  fullName,
  netWorthCategory,
  advisorName,
  clientSince,
  isActive
}) => {
  const metadataTags = [
    netWorthCategory,
    advisorName,
    clientSince
  ].filter(Boolean)

  return (
    <div className="client-header">
      <h1 className="client-header-name">{fullName}</h1>
      <div className="client-header-metadata">
        {metadataTags.map((tag, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span className="metadata-separator">|</span>}
            <span className="metadata-tag">{tag}</span>
          </React.Fragment>
        ))}
        {metadataTags.length > 0 && <span className="metadata-separator">|</span>}
        <StatusBadge isActive={isActive} />
      </div>
    </div>
  )
}
